import React from 'react';
import {
  Bot,
  Clock3,
  Globe2,
  MessageSquareOff,
  PackageOpen,
  Truck
} from 'lucide-react';

const icons = [MessageSquareOff, PackageOpen, Truck, Globe2, Bot, Clock3];

export function WsjPedidosProblemsSection({ copy }) {
  return (
    <section id="wsj-pedidos-problems" className="max-w-6xl mx-auto mb-20 sm:mb-28 scroll-mt-28">
      <div className="text-center mb-10 sm:mb-12">
        <h2 className="text-2xl sm:text-4xl font-black text-white tracking-tight break-words px-1">{copy.sectionProblemsTitle}</h2>
        <p className="text-white/50 mt-3 max-w-2xl mx-auto font-light leading-relaxed break-words">{copy.sectionProblemsLead}</p>
      </div>
      <div className="w-20 h-1 bg-gradient-to-r from-amber-500 to-emerald-500/80 mx-auto rounded-full mb-10 sm:mb-12 opacity-90" />

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
        {copy.problemCards.map((card, i) => {
          const Icon = icons[i] || MessageSquareOff;
          return (
            <div
              key={card.title}
              className="group relative rounded-2xl border border-white/[0.07] bg-slate-950/45 backdrop-blur-md p-5 sm:p-6 overflow-hidden transition-all duration-300 hover:border-red-400/20 hover:bg-slate-950/65 hover:shadow-[0_20px_60px_-28px_rgba(239,68,68,0.12)]"
            >
              <div
                className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-br from-red-500/[0.07] via-transparent to-transparent"
                aria-hidden
              />
              <div className="relative">
                <div className="w-11 h-11 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform duration-300">
                  <Icon className="w-5 h-5 text-red-300/90" aria-hidden />
                </div>
                <h3 className="text-base font-bold text-white mb-2 tracking-tight">{card.title}</h3>
                <p className="text-sm text-white/45 leading-relaxed font-light break-words min-w-0">{card.desc}</p>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-12 sm:mt-14 rounded-2xl border border-emerald-500/20 bg-gradient-to-r from-emerald-500/[0.08] via-slate-950/50 to-amber-500/[0.06] px-6 py-8 sm:px-10 sm:py-9 text-center shadow-[0_24px_80px_-40px_rgba(16,185,129,0.15)]">
        <p className="text-lg sm:text-xl font-semibold text-white/95 max-w-3xl mx-auto leading-snug break-words px-1">{copy.problemsClosing}</p>
      </div>
    </section>
  );
}
